export const PARENT_PRODUCTS = {
	CONFLUENCE: 'confluence',
	JIRA: 'jira',
	TEAMS: 'teams',
} as const;

export interface PanelDataMap {
	actions?: {
		onClose: () => void;
		onExpand: () => void;
		onOpenInNewTab?: () => void;
	};
	embedUrl?: string;
}
